<div class="overlay" *ngIf="isOpen" (click)="closeDrawer()" [class.open]="isOpen"></div>
<div class="drawer" [class.open]="isOpen" [style.width]="width" [style.max-width]="maxWidth" #contentWrapper>
  <ng-content></ng-content>
</div>
